import type { ReactNode } from 'react';
import { Icon } from './Icon';

export type BannerTone = 'warn' | 'bad' | 'info' | 'good' | 'plain';
const cls: Record<BannerTone, string> = { warn: ' w', bad: ' b', info: ' i', good: ' g', plain: '' };
const icon = { warn: 'review', bad: 'alert', info: 'info', good: 'check', plain: null } as const;

/**
 * The reference banner, with tones. `bad` is announced as an alert, the others as status.
 * Used for budget hit, expired Google connection, paused jobs, viewing old data.
 */
export function Banner({ tone = 'warn', children, actions }: { tone?: BannerTone; children: ReactNode; actions?: ReactNode }) {
  const ic = icon[tone];
  return (
    <div className={`banner${cls[tone]}`} role={tone === 'bad' ? 'alert' : 'status'}>
      {ic ? <Icon name={ic} /> : null}
      <div className="bx">{children}</div>
      {actions ? <div className="act">{actions}</div> : null}
    </div>
  );
}
